import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})


export class ShopService {
    shop: string;
    nextOrderDate: string;
    lastOrderDate: string;
  title: string;

  shopData: any;

    private emitChangeTitle = new Subject<string>();
    // Observable string streams
    changeTitle$ = this.emitChangeTitle.asObservable();
    // Service message commands
    emitTitle(change: any) {
        this.title = change;
        this.emitChangeTitle.next(change);
    }

    private emitChangeSource = new Subject<string>();
    // Observable string streams
    changeEmitted$ = this.emitChangeSource.asObservable();
    // Service message commands
    emitChange(change: any) {
        this.shop = change;
        this.emitChangeSource.next(change);
    }


    private emitChangeCategory = new Subject<string>();
    // Observable string streams
    changeCategoryEmitted$ = this.emitChangeCategory.asObservable();
    // Service message commands
    emitCategory(change: any) {
      this.emitChangeCategory.next(change);
    }



    //messaging
    private emitOrderdatesSource = new Subject<any>();
    //private emitLastorderdateSource = new Subject<any>();
    // Observable string streams
    changeOrderdates$ = this.emitOrderdatesSource.asObservable();
    //changeLastorderdate$ = this.emitLastorderdateSource.asObservable();
    // Service message commands
    emitOrderdates(change: any) {
        this.emitOrderdatesSource.next(change);
       // this.emitLastorderdateSource.next(change.LastOrderDate);
        this.nextOrderDate = change.NextOrderDate;
        this.lastOrderDate = change.LastOrderDate;
    }

    private emitShopSource = new Subject<any>();
    changeShop$ = this.emitShopSource.asObservable();
    emitShop(change: any) {
        this.shopData = change;
        sessionStorage.setItem('shopData', JSON.stringify(change)); // Save data
        this.emitShopSource.next(change);
    }

    getShopFromStorage() {
        const storedData = sessionStorage.getItem('shopData');
        return storedData ? JSON.parse(storedData) : null;
    }

   
}
